<template>
  <div class="contract-container">
   <div class="red_top_bg">
     <div class="back_left" @click="$router.back()">返回</div>
     <div class="big_tit">认购合同</div>
   </div>
    
    <div class="contract-content">
      <div class="company-title">金花企业（集团）股份有限公司</div>
      
      <div class="party-info">
        <div class="party-item">
          <div class="party-label">甲方（认购方）:</div>
          <div class="party-name">{{ contract.parties.buyer }}</div>
        </div>
        <div class="party-item">
          <div class="party-label">乙方（管理方）:</div>
          <div class="party-name">{{ contract.parties.manager }}</div>
        </div>
        <div class="party-item">
          <div class="party-label">丙方（担保方）:</div>
          <div class="party-name">{{ contract.parties.guarantor }}</div>
        </div>
      </div>
      
      <div class="contract-intro">
        甲乙丙双方经友好协商，本着平等自愿、诚实信用的原则就甲方使用乙方提供的本网站所有服务的有关事项达成如下协议：
      </div>
      
      <table class="contract-table">
        <tbody>
          <tr v-for="(item, key) in contract.details" :key="key">
            <td>{{ key }}</td>
            <td>{{ item }}</td>
          </tr>
        </tbody>
      </table>
      
      <div class="signature-section">
        <div class="signature-row">
          <div class="signature-item">
            <div class="signature-label">甲方:</div>
            <div class="signature-name">{{ contract.parties.buyer }}</div>
          </div>
          <div class="signature-item">
            <div class="signature-label">乙方:</div>
            <div class="signature-name">{{ contract.parties.manager }}</div>
            <img src="../images/user/cash/121.png" class="signature-stamp" alt="乙方印章">
          </div>
        </div>
        
        <div class="date-section">
          {{ contract.date }}
        </div>
        
        <div class="signature-row">
          <div class="signature-item">
            <div class="signature-label">丙方:</div>
            <div class="signature-name">{{ contract.parties.guarantor }}</div>
            <img src="../images/user/cash/2.png" class="signature-stamp" alt="丙方印章">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch'

export default {
  name: "SubscriptionContract",
  data() {
    return {
      contract: {
        parties: {
          buyer: '',
          manager: '金花企业（集团）股份有限公司',
          guarantor: '中国人民保险集团股份有限公司'
        },
        details: {
          '产品名称': '',
          '认购人姓名': '',
          '认购人身份证': '',
          '投入本金数额(下称"甲方认购本金")': '',
          '协议期': '',
          '预期收益率': '',
          '起息日': '',
          '到期日': '',
          '还款方式': '到期还本返息'
        },
        date: '',
        stamps: {
          manager: '../images/user/cash/15.png',
          guarantor: '../images/user/cash/2.png'
        }
      },
      contractId: null,
      loading: true
    }
  },
  mounted() {
    // 从路由查询参数获取合同ID
    this.getContractIdFromQuery()
    this.loadContractData()
  },
  methods: {
    // 从路由查询参数获取ID
    getContractIdFromQuery() {
      this.contractId = this.$route.query.id
      console.log('获取到的合同ID:', this.contractId)
      if (!this.contractId) {
        console.error('无法从路由参数中获取合同ID')
      }
    },
    
    loadContractData() {
      if (!this.contractId) {
        console.error('合同ID为空')
        return
      }
      
      this.loading = true
      // 调用订单接口获取数据
      Fetch('/user/order').then((r) => {
        if (r.code === 1 && r.data.list) {
          // 根据合同ID找到对应的订单
          const order = r.data.list.find(item => item.id == this.contractId)
          if (order) {
            this.updateContractData(order)
          } else {
            console.error('未找到对应的订单数据，ID:', this.contractId)
            console.log('可用订单列表:', r.data.list)
          }
        }
        this.loading = false
      }).catch(err => {
        console.error('加载合同数据失败:', err)
        this.loading = false
      })
    },
    
    updateContractData(order) {
      console.log('更新合同数据:', order)
      
      // 更新甲方信息
      this.contract.parties.buyer = order.user_name || ''
      
      // 更新合同详情
      this.contract.details = {
        '产品名称': order.zh_cn || '非',
        '认购人姓名': order.user_name || '',
        '认购人身份证': this.formatIdCard(order.user_idcard || ''),
        '投入本金数额(下称"甲方认购本金")': this.formatMoney(order.money || '0'),
        '协议期': `${order.day}分钟`,
        '预期收益率': `${order.rate}%`,
        '起息日': order.time || '',
        '到期日': order.time2 || '',
        '还款方式': '到期还本返息'
      }
      
      // 设置合同日期为投资时间
      this.contract.date = order.time || ''
    },
    
    // 格式化身份证号（隐藏部分数字）
    formatIdCard(idCard) {
      if (!idCard) return ''
      if (idCard.length <= 8) return idCard
      const start = idCard.substring(0, 4)
      const end = idCard.substring(idCard.length - 4)
      return `${start}${'*'.repeat(idCard.length - 8)}${end}`
    },
    
    // 格式化金额
    formatMoney(money) {
      const num = parseFloat(money) || 0
      return num.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '元'
    }
  }
}
</script>

<style lang="less" scoped>
	.big_tit {
	    position: absolute;
	    height: 25px;
	    font-size: 18px;
	    font-weight: 500;
	    color: #ffffff;
	    line-height: 25px;
	    top: 23px;
	    left: 50%;
	    transform: translateX(-50%);
	}
	.red_top_bg {
	  height: 168px;
	  background: linear-gradient(to left, #5674d3, #a8b6e5);
	  height: 50px;
	}
.contract-container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 40px;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #1a6dbb 0%, #2c8bd1 100%);
  color: white;
  position: relative;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  margin-right: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateX(-2px);
}

.header-title {
  font-size: 18px;
  font-weight: 600;
}

.contract-content {
  padding: 30px;
}

.company-title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: #1a6dbb;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}

.party-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.party-item {
  flex: 1;
  padding: 0 10px;
}

.party-label {
  font-weight: 600;
  color: #555;
  margin-bottom: 5px;
}

.party-name {
  font-size: 16px;
  color: #333;
}

.contract-intro {
  margin-bottom: 20px;
  color: #666;
  line-height: 1.8;
}

.contract-table {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  overflow: hidden;
}

.contract-table th {
  background-color: #f1f7fd;
  padding: 14px 15px;
  text-align: left;
  font-weight: 600;
  color: #1a6dbb;
  border-bottom: 1px solid #e1e8f0;
}

.contract-table td {
  padding: 14px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.contract-table tr:last-child td {
  border-bottom: none;
}

.contract-table tr:nth-child(even) {
  background-color: #fafbfc;
}

.signature-section {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px dashed #ddd;
}

.signature-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.signature-item {
  flex: 1;
  padding: 0 20px;
  position: relative;
}

.signature-label {
  font-weight: 600;
  margin-bottom: 10px;
  color: #555;
}

.signature-name {
  font-size: 16px;
  margin-bottom: 10px;
}

.signature-stamp {
  position: absolute;
 left:35px;
  top: -10px;
  width: 80px;
  opacity: 0.9;
}

.date-section {
  text-align: center;
  margin-top: 30px;
  color: #666;
  font-size: 15px;
}

@media (max-width: 768px) {
  .contract-container {
    margin: 10px;
    border-radius: 0;
  }
  
  .party-info, .signature-row {
    flex-direction: column;
  }
  
  .party-item, .signature-item {
    margin-bottom: 15px;
    padding: 0;
  }
  
  .contract-content {
    padding: 20px 15px;
  }
  
  .contract-table {
    font-size: 14px;
  }
  
  .contract-table th, .contract-table td {
    padding: 10px 8px;
  }
}
</style>